import PUSH_ERRORS from 'cio/utils/errors/messages/push';
import escape from 'cio/utils/escape';

function parseError(error) {
  try {
    return JSON.parse(error);
  } catch (_) {
    return null;
  }
}

function errorObjectToString(error) {
  let message = [];

  if (error.code) {
    message.push(`<b>${error.code}:</b>`);
  }

  if (error.message) {
    message.push(error.message);
  } else {
    message.push(error);
  }

  return message.join(' ');
}

function reduceToSingleErrorIfPossible(parsedErrors, deliveryState) {
  // If there's a single error, we return that
  if (parsedErrors.length === 1) {
    let [firstError] = parsedErrors;
    return firstError;
  }

  // If there's a single error that matches the parent deliveryState, we return that
  let errorsWithParentDeliveryState = parsedErrors.filter((error) => {
    if (deliveryState === 'failed') {
      return error.status !== 200;
    }

    return error[deliveryState];
  });

  if (errorsWithParentDeliveryState.length === 1) {
    let [firstError] = errorsWithParentDeliveryState;
    return firstError;
  }

  return undefined;
}

function formatPushError(error, variant) {
  let key = typeof error === 'string' ? error : error.detail;
  let formattedError = PUSH_ERRORS[key];

  // if error not configured and the error object cannot be parsed as JSON, just render it
  if (!formattedError) {
    return escape(key);
  }

  // if configured error is just a string, render it
  if (typeof formattedError === 'string') {
    return formattedError;
  }

  // if configured error has only one message variant, render it
  if (typeof formattedError.message === 'string') {
    return errorObjectToString(formattedError);
  }

  // if configured error has a function to render dynamic message, render it
  if (typeof formattedError.message === 'function') {
    formattedError = {
      ...formattedError,
      message: formattedError.message(error),
    };
    return errorObjectToString(formattedError);
  }

  // if specified error variant isn't defined, render default
  if (!formattedError.message[variant]) {
    variant = 'default';
  }

  formattedError = {
    ...formattedError,
    message: formattedError.message[variant],
  };

  return errorObjectToString(formattedError);
}

export default function pushFormatter(error, variant, deliveryState) {
  let parsedErrors = parseError(error);

  if (parsedErrors) {
    let singleError = reduceToSingleErrorIfPossible(parsedErrors, deliveryState);

    // Otherwise, we create a custom string and return that.
    return singleError
      ? formatPushError(singleError, variant)
      : `${parsedErrors.length} devices ${deliveryState}. See the Delivery Details page for more info.`;
  }

  return formatPushError(error, variant);
}
